import { FC, useCallback, useState, useEffect } from 'react'

/* Utils */
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { UserServiceV4 } from 'services'

/* Components */
import { Container } from './account-management.styles'
import { modalPropsSelector, setModalProps } from '../../../../store/modals/modalSlice'
import HeaderComponent from '../../../components/header/HeaderComponent'
import { breadcrumbs } from '../../../../lib/utils'
import ContentWrapper from '../../../components/header/ContentWrapper'
import UserProfile from '../../../components/modal/variants/user-profile/UserProfile'

const Profile: FC = () => {
  const [loading, setLoading] = useState(true)
  const dispatch = useAppDispatch()
  const modalProps = useAppSelector(modalPropsSelector)

  const fetchUser = useCallback(async () => {
    setLoading(true)

    try {
      return await UserServiceV4.getMe()
    } catch (err) {
      console.error(err)
    }
  }, [])

  useEffect(() => {
    fetchUser()
      .then((user) => {
        dispatch(
          setModalProps({
            open: false,
            props: {
              ...modalProps.props,
              user
            }
          })
        )
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <Container>
      <HeaderComponent breadcrumbs={breadcrumbs.profile} />

      <ContentWrapper line={1}>
        <>{!loading && <UserProfile />}</>
      </ContentWrapper>
    </Container>
  )
}

export default Profile
